"use client";

import { useState, useEffect } from "react";

export function useIsMobile(breakpoint = 768) {
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);
		const check = () => setIsMobile(mq.matches);

		check();
		mq.addEventListener("change", check);
		return () => mq.removeEventListener("change", check);
	}, [breakpoint]);

	return isMobile;
}
